/**
 * TRUTEX AUTOMOTIVE - AJAX Cart Scripts (assets/cart-scripts.js)
 * High-performance, real-time Shopify AJAX Cart Engine
 * 
 * Features:
 * - Dynamic variant mapping validation
 * - Real-time quantity increment/decrement ([ - ] / [ + ]) via /cart/change.js
 * - Instant item removal (trash icon / remove trigger)
 * - Live Subtotal and badge refresh without closing the drawer
 * - Portuguese (PT-PT) currency formatting
 */

(function() {
  'use strict';

  // Format money helper according to active market & currency
  function formatMoneyPT(cents, currencyCode) {
    if (isNaN(cents)) return '0,00 €';
    const currency = currencyCode || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || localStorage.getItem('trutex_user_currency') || 'EUR';
    const amount = (cents / 100).toFixed(2);

    if (currency === 'USD') {
      return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    if (currency === 'GBP') {
      return '£' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    const parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join(',') + ' €';
  }

  // Update header and navigation cart counters
  function updateCartCounters(count) {
    const badges = document.querySelectorAll('.cart-badge-count, [data-cart-count]');
    badges.forEach(badge => {
      badge.textContent = count;
      if (count > 0) {
        badge.style.display = 'flex';
        badge.removeAttribute('hidden');
      } else {
        badge.style.display = 'none';
      }
    });
  }

  // Open Cart Drawer
  window.openCartDrawer = function() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-drawer-overlay');
    if (drawer) drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  // Close Cart Drawer
  window.closeCartDrawer = function() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-drawer-overlay');
    if (drawer) drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  // Render Cart Drawer dynamically from Shopify Cart JSON
  window.renderCartDrawer = function(cart) {
    const container = document.getElementById('cart-drawer-items');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    const countHeader = document.getElementById('cart-drawer-item-count');
    const footerEl = document.querySelector('.cart-drawer-footer');

    if (countHeader) {
      countHeader.textContent = cart.item_count === 1 ? '1 artigo' : cart.item_count + ' artigos';
    }

    updateCartCounters(cart.item_count);

    if (subtotalEl) {
      subtotalEl.textContent = formatMoneyPT(cart.total_price);
    }

    if (!container) return;

    if (!cart || cart.item_count === 0) {
      container.innerHTML = `
        <div style="text-align: center; padding: 60px 20px; color: #a1a1aa;">
          <div style="width: 64px; height: 64px; margin: 0 auto 16px; border-radius: 50%; background: #18181b; border: 1px solid #27272a; display: flex; align-items: center; justify-content: center; color: #71717a;">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="8" cy="21" r="1"></circle>
              <circle cx="19" cy="21" r="1"></circle>
              <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
            </svg>
          </div>
          <p style="font-size: 1.05rem; font-weight: 700; color: #ffffff; margin-bottom: 8px;">O teu carrinho está vazio.</p>
          <p style="font-size: 0.85rem; color: #71717a; margin-bottom: 24px;">Explora os nossos volantes desportivos e componentes exclusivos.</p>
          <a href="/collections/all" class="btn btn-secondary" style="display: inline-block; padding: 12px 24px; font-size: 0.85rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; border-radius: 8px;">
            Ver Catálogo
          </a>
        </div>
      `;
      if (footerEl) {
        footerEl.style.display = 'none';
      }
      return;
    }

    if (footerEl) {
      footerEl.style.display = 'block';
    }

    let html = '<div style="display: flex; flex-direction: column;">';

    cart.items.forEach((item, index) => {
      const isLast = index === cart.items.length - 1;
      const borderStyle = isLast ? '' : 'border-bottom: 1px solid rgba(255, 255, 255, 0.08);';
      const variantDisplay = item.variant_title && !item.variant_title.includes('Default')
        ? `<div style="font-size: 0.78rem; color: #a1a1aa; margin-top: 2px;">${item.variant_title}</div>`
        : '';

      let propertiesDisplay = '';
      if (item.properties && typeof item.properties === 'object') {
        const propEntries = Object.entries(item.properties).filter(([k, v]) => v && !k.startsWith('_'));
        if (propEntries.length > 0) {
          propertiesDisplay = `
            <div class="cart-item-properties" style="margin-top: 6px; padding: 6px 8px; background: rgba(255, 255, 255, 0.04); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 6px; font-size: 0.72rem; line-height: 1.4;">
              ${propEntries.map(([k, v]) => `
                <div style="display: flex; gap: 4px; justify-content: space-between;">
                  <span style="color: #a1a1aa;">${k}:</span>
                  <span style="color: #ef4444; font-weight: 700;">${v}</span>
                </div>
              `).join('')}
            </div>
          `;
        }
      }

      const itemImg = item.featured_image && item.featured_image.url
        ? item.featured_image.url
        : (item.image || '');

      html += `
        <div class="cart-drawer-item" data-line-key="${item.key}" style="display: flex; gap: 14px; padding: 18px 0; ${borderStyle} background: #000000;">
          <div style="width: 72px; height: 72px; border-radius: 8px; overflow: hidden; background: #111116; border: 1px solid rgba(255, 255, 255, 0.1); flex-shrink: 0;">
            ${itemImg ? `<img src="${itemImg}" alt="${item.title}" style="width: 100%; height: 100%; object-fit: cover;" />` : ''}
          </div>

          <div style="flex-grow: 1; display: flex; flex-direction: column; justify-content: space-between;">
            <div>
              <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
                <h4 style="margin: 0; font-size: 0.9rem; font-weight: 800; color: #ffffff; line-height: 1.3;">
                  <a href="${item.url}" style="color: #ffffff; text-decoration: none;">${item.product_title}</a>
                </h4>
                <button 
                  type="button" 
                  class="cart-remove-btn"
                  data-cart-remove="${item.key}"
                  title="Remover produto"
                  style="background: none; border: none; padding: 4px; color: #71717a; cursor: pointer; transition: color 0.2s;"
                  onmouseover="this.style.color='#ef4444'" 
                  onmouseout="this.style.color='#71717a'"
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
              ${variantDisplay}
              ${propertiesDisplay}
            </div>

            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 12px;">
              <!-- Quantity Selectors [ - ] [ + ] with PT-PT Label -->
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="font-size: 0.75rem; color: #a1a1aa; font-weight: 600; text-transform: uppercase;">Quantidade:</span>
                <div style="display: inline-flex; align-items: center; background: #111116; border: 1px solid rgba(255, 255, 255, 0.15); border-radius: 6px; padding: 2px;">
                  <button 
                    type="button" 
                    class="qty-btn"
                    data-cart-change="${item.key}"
                    data-qty="${item.quantity - 1}"
                    aria-label="Diminuir quantidade"
                    style="width: 26px; height: 26px; background: transparent; border: none; color: #ffffff; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 800;"
                    onmouseover="this.style.color='#e31b23'"
                    onmouseout="this.style.color='#ffffff'"
                  >&minus;</button>
                  <span style="min-width: 24px; text-align: center; font-size: 0.8rem; font-weight: 800; color: #ffffff;">${item.quantity}</span>
                  <button 
                    type="button" 
                    class="qty-btn"
                    data-cart-change="${item.key}"
                    data-qty="${item.quantity + 1}"
                    aria-label="Aumentar quantidade"
                    style="width: 26px; height: 26px; background: transparent; border: none; color: #ffffff; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 800;"
                    onmouseover="this.style.color='#e31b23'"
                    onmouseout="this.style.color='#ffffff'"
                  >+</button>
                </div>
              </div>

              <!-- Item Price -->
              <span style="font-size: 1rem; font-weight: 900; color: #ffffff; font-family: var(--font-display, sans-serif); letter-spacing: -0.01em;">
                ${formatMoneyPT(item.final_line_price)}
              </span>
            </div>
          </div>
        </div>
      `;
    });

    html += '</div>';
    container.innerHTML = html;
  };

  // Fetch Cart from Shopify API
  window.fetchShopifyCart = async function() {
    try {
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (response.ok) {
        const cart = await response.json();
        window.renderCartDrawer(cart);
        return cart;
      }
    } catch (err) {
      console.warn('[TRUTEX AJAX Cart] Fetch cart error:', err);
    }
    return null;
  };

  // Update line item quantity via /cart/change.js
  window.updateCartItemQuantity = async function(key, quantity) {
    const container = document.getElementById('cart-drawer-items');
    if (container) {
      container.style.opacity = '0.6';
      container.style.pointerEvents = 'none';
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: Math.max(0, parseInt(quantity, 10))
        })
      });

      if (response.ok) {
        const cart = await response.json();
        window.renderCartDrawer(cart);
      } else {
        const error = await response.json();
        console.error('[TRUTEX Cart Change Error]:', error);
      }
    } catch (err) {
      console.error('[TRUTEX Cart Network Error]:', err);
    } finally {
      if (container) {
        container.style.opacity = '1';
        container.style.pointerEvents = 'auto';
      }
    }
  };

  // Add Product to Cart via AJAX with dynamic variant mapping and state cleaning
  window.addDynamicProductToCart = async function(variantId, quantity = 1, formElement = null, customProperties = null) {
    if (!variantId) {
      console.error('[TRUTEX AJAX Cart] Erro: variantId não especificado.');
      return;
    }

    // 1. Limpar rigorosamente qualquer estado anterior ou IDs residuais
    const cleanVariantId = String(variantId).trim();
    const cleanQuantity = Math.max(1, parseInt(quantity, 10) || 1);

    // Extrair propriedades de linha personalizadas (ex: Vehicle, Chassis, Year, Paddle Shifters)
    const properties = { ...(customProperties || {}) };
    if (formElement) {
      const propInputs = formElement.querySelectorAll('[name^="properties["]');
      propInputs.forEach(input => {
        const match = input.name.match(/^properties\[(.*?)\]$/);
        if (match && match[1] && input.value !== undefined && input.value !== '') {
          properties[match[1]] = input.value;
        }
      });
    }

    let submitBtn = null;
    let originalText = '';

    if (formElement) {
      submitBtn = formElement.querySelector('button[type="submit"], [name="add"], .btn-primary');
      if (submitBtn) {
        originalText = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.innerHTML = `
          <svg style="animation: spin 0.8s linear infinite; width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 6px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" stroke-opacity="0.25"></circle>
            <path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"></path>
          </svg>
          A ADICIONAR...
        `;
      }
    }

    // 2. Feedback visual no drawer (reset de opacidade durante a transição)
    const container = document.getElementById('cart-drawer-items');
    if (container) {
      container.style.opacity = '0.5';
      container.style.pointerEvents = 'none';
    }

    try {
      // 3. Envio dinâmico isolado do ID exato e propriedades para o endpoint do Shopify
      const payloadBody = {
        id: cleanVariantId,
        quantity: cleanQuantity
      };
      if (Object.keys(properties).length > 0) {
        payloadBody.properties = properties;
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payloadBody)
      });

      if (response.ok) {
        const addedItem = await response.json();
        // 4. Limpar e atualizar dados em tempo real
        await window.fetchShopifyCart();
        window.openCartDrawer();
        return addedItem;
      } else {
        const errorData = await response.json();
        console.error('[TRUTEX Cart Add Error]:', errorData);
        alert(errorData.description || 'Não foi possível adicionar o produto ao carrinho.');
      }
    } catch (err) {
      console.warn('[TRUTEX Cart Add Dev/Local]:', err);
      // Fallback gracioso para modo de visualização local
      window.openCartDrawer();
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
      if (container) {
        container.style.opacity = '1';
        container.style.pointerEvents = 'auto';
      }
    }
  };

  // Compatibilidade com chamada universal addItemToCart
  window.addItemToCart = window.addDynamicProductToCart;

  // Event Listeners Initialization
  document.addEventListener('DOMContentLoaded', function() {
    // Open drawer triggers
    document.querySelectorAll('[data-cart-trigger], .cart-trigger-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.openCartDrawer();
      });
    });

    // Close drawer triggers
    document.querySelectorAll('[data-cart-close]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.closeCartDrawer();
      });
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        window.closeCartDrawer();
      }
    });

    // Intercept quantity changes & item removals via event delegation
    document.addEventListener('click', function(e) {
      // Quantity change [ - ] or [ + ]
      const changeBtn = e.target.closest('[data-cart-change]');
      if (changeBtn) {
        e.preventDefault();
        const key = changeBtn.getAttribute('data-cart-change');
        const qty = parseInt(changeBtn.getAttribute('data-qty'), 10);
        if (key) {
          window.updateCartItemQuantity(key, qty);
        }
        return;
      }

      // Remove button (trash icon or link)
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.getAttribute('data-cart-remove');
        if (key) {
          window.updateCartItemQuantity(key, 0);
        }
        return;
      }
    });

    // Intercept Product Form Submissions for Dynamic Variant ID mapping
    // Garante que isola APENAS o formulário submetido e limpa o estado anterior
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      const isProductForm = 
        form.id === 'trutex-product-form' || 
        form.classList.contains('product-form') || 
        form.getAttribute('action')?.includes('/cart/add');

      if (isProductForm) {
        e.preventDefault();
        e.stopPropagation();

        // 1. Obter o input [name="id"] especificamente e unicamente dentro DESTE formulário
        let targetVariantId = null;
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.value) {
          targetVariantId = idInput.value.trim();
        }

        // 2. Se não estiver num hidden input, procurar no select[name="id"] do formulário
        if (!targetVariantId) {
          const selectElement = form.querySelector('select[name="id"]');
          if (selectElement && selectElement.value) {
            targetVariantId = selectElement.value.trim();
          }
        }

        const qtyInput = form.querySelector('input[name="quantity"]');
        const quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;

        if (targetVariantId) {
          // Enviar estritamente o ID correspondente ao produto atual (Audi, BMW, Mercedes, etc.)
          window.addDynamicProductToCart(targetVariantId, quantity, form);
        } else {
          // Fallback tradicional
          form.submit();
        }
      }
    });

    // Initial cart load
    window.fetchShopifyCart();
  });

})();
